import { useEffect } from "react";

/**
 * Injects a <script type="application/ld+json"> tag into <head>, keyed by
 * id so repeated calls update in place instead of stacking duplicates.
 * Removed on unmount so navigating away doesn't leave stale schema behind.
 * Pass `data: null` (e.g. while a product/category is still loading) to
 * skip rendering until real data is available.
 */
export function useJsonLd(id: string, data: object | null) {
  const json = data ? JSON.stringify(data) : null;

  useEffect(() => {
    if (!json) return;
    let script = document.getElementById(id) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = id;
      document.head.appendChild(script);
    }
    script.textContent = json;

    return () => {
      document.getElementById(id)?.remove();
    };
  }, [id, json]);
}
